// extracted by mini-css-extract-plugin
export default {"previewButton":"u7VV5","buttons":"fFy26","graphContainer":"d7EIR","collectedAmount":"OZPfU","collectedText":"QLlBp"};